import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '@app/app-config.service';
import { Observable } from 'rxjs';

export interface MarketingInfo {
  title: string;
  summary: string;
  url: string;
}

@Injectable({
  providedIn: 'root'
})
export class MarketingInfoService {
  protected baseUrl;

  constructor(private http: HttpClient, private appConfigService: AppConfigService) {
    this.baseUrl = appConfigService.isExternal()
      ? `${appConfigService.getBlob()}/${appConfigService.getEnvName()}`
      : '';
  }

  getMarketingInfo(language: string): Observable<MarketingInfo> {
    return this.http.get<MarketingInfo>(`${this.baseUrl}/assets/features/login/${language}/data.json`);
  }
}
